.content {
  display: flex;
  gap: var(--spacingMd);
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;

  .actions {
    margin-left: auto;
    display: flex;
    gap: var(--spacingMd);
  }
}

.endAdornmentButton {
  padding: var(--spacingMd);
}
